module.exports = __webpack_public_path__ + "img/19-DCC.dd8d401b.jpg";